import { CommonEnums } from 'src/app/shared/common.enums';

export class TStg_Inst {
    tStg_Inst_Id: number;
    dxMp_Id: number;
    nm: string;
    description: string;
    ver: string;
    tstgType: string;
    valid_Cd: string;
    persistFlg: string;
    updateDt: Date;
    updateBy: string;
    lastUpdateBy: string;
    gen_Tab_Valid_Cd: string;
    attr_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.tStg_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.tstgType = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.persistFlg = CommonEnums.defaults.STRING_VAL_YES;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.gen_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
    }

    static parse(tStg_InstTmp: TStg_Inst): TStg_Inst {
        let tStg_Inst: TStg_Inst = new TStg_Inst();
        tStg_Inst.copyFrom(tStg_InstTmp);
        return tStg_Inst;
    }

    getPrimaryKey(): string {
        return this.tStg_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): TStg_Inst {
        let tStg_InstTmp: TStg_Inst = new TStg_Inst();

        tStg_InstTmp.tStg_Inst_Id = this.tStg_Inst_Id;
        tStg_InstTmp.dxMp_Id = this.dxMp_Id;
        tStg_InstTmp.nm = this.nm;
        tStg_InstTmp.description = this.description;
        tStg_InstTmp.ver = this.ver;
        tStg_InstTmp.tstgType = this.tstgType;
        tStg_InstTmp.valid_Cd = this.valid_Cd;
        tStg_InstTmp.persistFlg = this.persistFlg;
        tStg_InstTmp.updateDt = this.updateDt;
        tStg_InstTmp.updateBy = this.updateBy;
        tStg_InstTmp.lastUpdateBy = this.lastUpdateBy;
        tStg_InstTmp.gen_Tab_Valid_Cd = this.gen_Tab_Valid_Cd;
        tStg_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;

        return tStg_InstTmp;
    }

    copyFrom(tStg_InstTmp: TStg_Inst): void {
        this.tStg_Inst_Id = tStg_InstTmp.tStg_Inst_Id;
        this.dxMp_Id = tStg_InstTmp.dxMp_Id;
        this.nm = tStg_InstTmp.nm;
        this.description = tStg_InstTmp.description;
        this.ver = tStg_InstTmp.ver;
        this.tstgType = tStg_InstTmp.tstgType;
        this.valid_Cd = tStg_InstTmp.valid_Cd;
        this.persistFlg = tStg_InstTmp.persistFlg;
        this.updateDt = tStg_InstTmp.updateDt;
        this.updateBy = tStg_InstTmp.updateBy;
        this.lastUpdateBy = tStg_InstTmp.lastUpdateBy;
        this.gen_Tab_Valid_Cd = tStg_InstTmp.gen_Tab_Valid_Cd;
        this.attr_Tab_Valid_Cd = tStg_InstTmp.attr_Tab_Valid_Cd;
    }

    compare(tStg_InstTmp: TStg_Inst): string {
        let tStg_InstString: string = this.toString(false);
        let tStg_InstTmpString: string = tStg_InstTmp.toString(false);

        if (tStg_InstString != tStg_InstTmpString) {
            return tStg_InstString + ', ' + tStg_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "TStg_Inst [tStg_Inst_Id=" + this.tStg_Inst_Id + ", dxMp_Id=" + this.dxMp_Id +
            ", nm=" + this.nm + ", description=" + this.description + ", tstgType=" + this.tstgType + ", valid_Cd=" + this.valid_Cd +
            ", persistFlg=" + this.persistFlg + ", gen_Tab_Valid_Cd=" + this.gen_Tab_Valid_Cd + ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd;

        if (isNotCompare) {
            str += ", ver=" + this.ver + ", updateDt=" + this.updateDt +
                ", updateBy=" + this.updateBy + ", lastUpdateBy=" + this.lastUpdateBy;
        }

        str += ']';
        return str;
    }
}